<template>
  <div class="fromPage">
    <v-tabs v-model="tab" fixed-tabs>
      <v-tab v-for="item in items" :key="item" @click="$addTags(tab == 0 ? tags.Epaper : tags.paper, null, null, null)">
        {{ item }}
      </v-tab>
    </v-tabs>
    <v-tabs-items v-model="tab">
      <v-tab-item>
        <div class="textBox">
          <p>協助手動輸入發票資訊，<br>更有利加速審核發放獎項唷！</p>
          <p>上傳之電子發票照片及登錄資訊須正確且能清晰辨識<br>若照片模糊、無法辨識或資格不符將喪失得獎資格</p>
        </div>
        <fromComponents :tab="tab" @getParentData="getParentData" />
      </v-tab-item>
      <v-tab-item>
        <div class="textBox">
          <p>上傳之傳統發票資訊請確保正確無誤<br>如資格不符將喪失得獎資格</p>
        </div>
        <fromComponents :tab="tab" @getParentData="getParentData" />
      </v-tab-item>
    </v-tabs-items>
    <googleRecapcha ref='googleRecapcha' @getGoogle="getGoogleRecapcha"></googleRecapcha>
    <popup :popupIconType="popupIconType" :popupItem="popupItem" :prize="prize" :inv_number="inv_number" v-if="dialog"
      @popupStatus="dialog=false" />
  </div>
</template>

<script>
  import axios from "axios";
  import swal from 'sweetalert2'
  import googleRecapcha from '@/components/googleRecapcha.vue';
  import popup from '../components/popup';
  import fromComponents from '../components/fromComponents'

  export default {
    name: 'fromPage',
    components: {
      popup,
      googleRecapcha,
      fromComponents,
    },
    props: [],
    data() {
      return {
        isActive: '',
        tab: null,
        parentInv_number: '',
        items: [
          '電子發票', '傳統發票',
        ],
        tags: {
          'Epaper': '239B36CFE9414150B814CE42B3CDF9AE',
          'paper': 'F1A7C8E90AD04199923855B9DB8497B8'
        },
        form: '',
        gCAPTCHA_token:'',
        dialog: false,
        popupIconType: '',
        popupItem: '',
        prize: '',
        inv_number:'',
      }
    },
    methods: {
      // 顯示popup視窗
      seePopUp(val, data) {
        this.dialog = true
        this.popupIconType = 'icon' + val
        this.popupItem = val
        this.prize = data.prize
        this.inv_number= data.inv_number
      },
      // 拿到子層資料
      getParentData(val) {
        this.form=val
        this.googleVerify()
      },
      // 打googleRecapcha
      googleVerify() {
        this.$refs.googleRecapcha.execute();
      },
      // 獲得googleRecapcha 資料
      getGoogleRecapcha(val) {
        this.gCAPTCHA_token = val
        this.addData()
      },
      // 傳資料
      addData() {
        var me = this;
        me.form.inv_type = me.tab + 1
        me.form.gCAPTCHA_token= me.gCAPTCHA_token
       
        if (me.form.inv_type == 1) {
          //電子發票
          me.url = '/Liff/AddData_EInvoiceEnrollment/E2B1ED123CD74351911A023587A9DEE0'
          delete(me.form.buyCity)
        } else {
          //傳統發票
          me.url = '/Liff/AddData_InvoiceEnrollment/F1F603B51C6C4EAEB3927CF7DCC51A06'
          delete(me.form.inv_randomNumber)
          delete(me.form.file_inv_photo)
        }
        var config = {
          method: "post",
          headers: {
            Authorization: `Bearer ${me.$accessToken}`,
          },
          url: me.$apiUrl + me.url,
          data: new FormData()
        }
        Object.keys(me.form).forEach(key => {
          switch (key) {
            case 'buyCity':
              config.data.append(key, `好好生活_購買地_${me.form[key]}`);
              break;
            case 'buyCategory':
              var newCategory = me.form[key].map(item => {
                return `好好生活_${item}`;
              })
              config.data.append(key, JSON.stringify(newCategory));
              break;
            case 'gender':
              config.data.append(key, `好好生活_性別_${me.form[key]}`);
              break;
            case 'liveCity':
              config.data.append(key, `好好生活_居住地_${me.form[key]}`);
              break;
            default:
              config.data.append(key, me.form[key]);
              break;
          }
        });

        swal.fire({
          didOpen: () => {
            swal.fire({
              allowOutsideClick: false
            });
            swal.showLoading();
            axios(config).then(res => {
              var data = res.data;
              if (data && data.success) {
                this.seePopUp('Check', data.data)
              } else {
                alert(data.message);
              }
            }).catch((err) => {
              console.log(err)
              alert("系統忙碌中，請稍後再試");
            }).finally(() => {
              swal.close();
            })
          }
        })
      },
    },
  }
</script>
<style lang="scss">
  #app {
    .fromPage .primary--text {
      color: #C35238 !important;
      caret-color: #C35238 !important;
    }
  }

  .fromPage {
    padding: 30px 15px;

    .container {
      padding: 0;
    }

    .v-tab {
      background: #EEE5B3;
      border-radius: 12px 12px 0 0;
      color: black;
      font-size: 22px;

      &+.v-tab {
        margin-left: 10px;
      }

      &.v-tab--active {
        background: #EBD559;
        color: #C35238;
      }
    }

    .v-tabs-items {

      .textBox {
        text-align: center;
        background: #EBD559;

        p {
          margin: 0;
          padding-top: 20px;
          font-size: 16px;

          &+p {
            font-size: 12px;
            color: #858585;
          }
        }
      }
    }
  }
</style>